import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HatchedBackground = (patternId, hatchColor, backgroundColor) => ({ x, y, width, height }) => {
    if (x !== undefined &&
        y !== undefined &&
        width !== undefined &&
        height !== undefined) {
        return (_jsxs("svg", Object.assign({ x: x, y: y, width: width, height: height, viewBox: `${x} ${y} ${width} ${height}`, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, { children: [_jsx("defs", { children: _jsxs("pattern", Object.assign({ id: patternId, patternUnits: "userSpaceOnUse", width: "4", height: "4" }, { children: [_jsx("path", { id: "background", d: "M-1,3 L3,-1\n               M1,5 L5,1", style: {
                                    stroke: backgroundColor,
                                    strokeWidth: 10,
                                    opacity: 0.25,
                                } }, void 0), _jsx("path", { id: "hatches", d: "M-2,2 L2,-2\n               M0,4 L4,0\n               M2,6 L6,2", style: { stroke: hatchColor, strokeWidth: 1, opacity: 0.35 } }, void 0)] }), void 0) }, void 0), _jsx("path", { fill: `url(#${patternId})`, x: x, y: y, width: width, height: height, d: `M0 0h1196v347H0z M ${x},${y} h ${width} v ${height} h -${width} Z`, opacity: ".574" }, void 0)] }), void 0));
    }
    else {
        return null;
    }
};
export default HatchedBackground;
